import React from 'react';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { isEmptyBlock, isNonEmptyBlock } from '../../types/api/Block';
import { DefaultAccordion } from '../../_lib/components/Accordion/DefaultAccordion';
import { mapContextBlock } from '../../_blocks/mapContextBlock';
import { RoleSettingsBlock } from '../../_blocks/RoleSettings/RoleSettingsBlock';
import { RoleDefaultForPageTypeSettingsBlock } from '../../_blocks/RoleSettings/RoleDefaultForPageTypeSettingsBlock';
import { useSonTranslation } from '../../translation/useSonTranslation';

type RoleSettingsBlocks = RoleSettingsBlock | RoleDefaultForPageTypeSettingsBlock;
export type RoleSettingsWidget = ContextWidget<RoleSettingsBlocks, WidgetType.rolesettings>;

export function RoleSettingsWidget({ blocks, elementType, ...headerProps }: RoleSettingsWidget) {
  const { t } = useSonTranslation('RoleSettings');

  if (blocks.every(isEmptyBlock)) {
    return null;
  }

  const accordionData = blocks.filter(isNonEmptyBlock).map(block => ({
    key: block.uuid,
    id: `${block.elementType}-${block.uuid}`,
    category: t(block.elementType),
    props: block as RoleSettingsBlocks,
  }));

  return (
    <DefaultWidgetWithHeader {...headerProps} widgetType={elementType} icon={Icons.SETTINGS} title={t('widgetTitle')}>
      <DefaultAccordion data={accordionData}>{({ props }) => mapContextBlock(props)}</DefaultAccordion>
    </DefaultWidgetWithHeader>
  );
}
